module.exports = __webpack_public_path__ + "img/license_header.f7f2f512.png";